import { Column } from '@tanstack/react-table';

import { Icon } from '@/new/components/icon';

/**
 * For use in table column headers. Shows a different icon depending on sort order and data type.
 */
export function SortIcon<T>({ column }: { column: Column<T, unknown> }) {
  if (!column.getCanSort()) return null;

  const sortOrder = column.getIsSorted();
  if (!sortOrder) {
    return (
      <div className="w-3 text-gray-400">
        <Icon className="lucide--arrow-up-down" />
      </div>
    );
  }

  let icons = {
    asc: <Icon className="lucide--arrow-up" />,
    desc: <Icon className="lucide--arrow-down" />,
  };

  switch (column.columnDef.meta?.sortIcon) {
    case 'string':
      icons = {
        asc: <Icon className="lucide--arrow-down-a-z" />,
        desc: <Icon className="lucide--arrow-down-z-a" />,
      };
      break;

    case 'number':
      icons = {
        asc: <Icon className="lucide--arrow-down-0-1" />,
        desc: <Icon className="lucide--arrow-down-1-0" />,
      };
      break;
  }

  return <div className="w-3 text-gray-400">{icons[sortOrder]}</div>;
}
